import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from "@sentry/react";
import App from './App.tsx';
import './index.css';
import { initWebVitals } from './utils/webVitals';

// Initialize Sentry for error tracking - optimized for performance
Sentry.init({
  dsn: "https://e20c3c5d55874e401635c1a4ea5c13d2@o4510318173618176.ingest.de.sentry.io/4510318227488848",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Performance Monitoring - reduced for mobile
  tracesSampleRate: 0.2, // Only 20% of transactions to reduce overhead
  // Session Replay - reduced for mobile performance
  replaysSessionSampleRate: 0.05, // Sample 5% of sessions (was 10%)
  replaysOnErrorSampleRate: 1.0, // Sample 100% of sessions with errors
  // Environment
  environment: import.meta.env.MODE,
  // Setting this option to true will send default PII data to Sentry
  sendDefaultPii: false, // Set to false for privacy (recommended)
  // Lazy load integrations
  beforeSend(event) {
    // Don't send events during page load for better performance
    if (document.readyState !== 'complete') {
      return null;
    }
    return event;
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Initialize Core Web Vitals monitoring
if (typeof window !== 'undefined') {
  initWebVitals();
}